import React, { useState, useEffect } from "react";
import { updateProfile } from "../../redux/actions/taskAction";
import firebase from "../../util/firebaseConfig";
import { useSelector, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
// Styles
import {
  Container,
  Divider,
  Form,
  Header,
  Input,
  Segment,
} from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
function Profile() {
  const uid = useSelector((state) => state.firebase.auth.uid);
  // const email = useSelector((state) => state.firebase.auth.email);
  const fullName = useSelector((state) => state.firebase.auth.displayName);
  const dispatch = useDispatch();

  const [hasProfile, setProfile] = useState(false);
  const [checked, setChecked] = useState(false);
  const [state, setState] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    birthday: "",
    officeNo: "",
    personalNo: "",
    strAdd: "",
    strAdd2: "",
    city: "",
    stateProvince: "",
    postalZip: "",
    country: "",
    authority: "",
    terms: false,
  });
  useEffect(() => {
    const db = firebase.firestore();
    db.collection("profile")
      .doc(uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          setProfile(true);
        }
      });

    // db.collection("members")
    //   .get()
    //   .then((snap) => {
    //     snap.forEach((doc) => {
    //       if (doc.data().email === email) {
    //         setState({
    //           ...state,
    //           authority: "Collaborator",
    //         });
    //       }
    //       // console.log("members:", doc.data());
    //     });
    //   });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // const nameArr = fullName && fullName.split(" ");

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateProfile(state));
  };

  if (!uid) return <Redirect to="/signin" />;
  if (hasProfile) return <Redirect to="/" />;
  return (
    <Container>
      <Segment clearing>
        <Form>
          <Form.Field>
            <Header>Profile</Header>
          </Form.Field>
          <Divider />
          {/* <Form.Field>
            <label>Selected payment plan: </label>
          </Form.Field> */}
          <Form.Group widths="equal">
            <Form.Field>
              <label>First name</label>
              <Input
                // disabled
                // value={nameArr && nameArr[0]}
                onChange={(e) =>
                  setState({
                    ...state,
                    firstName: e && e.target && e.target.value,
                  })
                }
                value={state.firstName}
                fluid
                placeholder="First name"
              />
            </Form.Field>
            <Form.Field>
              <label>Middle name</label>
              <Input
                // disabled
                // value={nameArr
                //   .slice(1, nameArr.length - 1)
                //   .join(" ")
                //   .trim()}
                value={state.middleName}
                onChange={(e) =>
                  setState({
                    ...state,
                    middleName: e && e.target && e.target.value,
                  })
                }
                fluid
                placeholder="Middle name"
              />
            </Form.Field>
            <Form.Field>
              <label>Last name</label>
              <Input
                // disabled
                // value={nameArr[nameArr.length - 1]}
                value={state.lastName}
                onChange={(e) =>
                  setState({
                    ...state,
                    lastName: e && e.target && e.target.value,
                  })
                }
                fluid
                placeholder="Last name"
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <DateInput
              dateFormat="MM-DD-YYYY"
              label="Date of Birth"
              value={state.birthday}
              iconPosition="left"
              onChange={(e, { value }) =>
                setState({
                  ...state,
                  birthday: value,
                })
              }
            />
            <Form.Field>
              <label>Office Number</label>
              <Input
                onChange={(e) =>
                  setState({
                    ...state,
                    officeNo: e && e.target && e.target.value,
                  })
                }
                fluid
                placeholder="Office Number"
              />
            </Form.Field>
            <Form.Field>
              <label>Personal Number (Optional)</label>
              <Input
                onChange={(e) =>
                  setState({
                    ...state,
                    personalNo: e && e.target && e.target.value,
                  })
                }
                fluid
                placeholder="Personal Number"
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <label>Street Address</label>
              <Input
                onChange={(e) =>
                  setState({
                    ...state,
                    strAdd: e && e.target && e.target.value,
                  })
                }
                fluid
                placeholder="Street Address"
              />
            </Form.Field>
            <Form.Field>
              <label>City</label>
              <Input
                onChange={(e) =>
                  setState({
                    ...state,
                    city: e && e.target && e.target.value,
                  })
                }
                fluid
                placeholder="City"
              />
            </Form.Field>
            <Form.Field>
              <label>State/Province</label>
              <Input
                onChange={(e) =>
                  setState({
                    ...state,
                    stateProvince: e && e.target && e.target.value,
                  })
                }
                fluid
                placeholder="State/Province"
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <label>Street Address 2</label>
              <Input
                onChange={(e) =>
                  setState({
                    ...state,
                    strAdd2: e && e.target && e.target.value,
                  })
                }
                fluid
                placeholder="Street Address 2"
              />
            </Form.Field>
            <Form.Field>
              <label>Postal/Zip</label>
              <Input
                onChange={(e) =>
                  setState({
                    ...state,
                    postalZip: e && e.target && e.target.value,
                  })
                }
                fluid
                placeholder="Postal/Zip"
              />
            </Form.Field>
            <Form.Field>
              <label>Country</label>
              <Input
                onChange={(e) =>
                  setState({
                    ...state,
                    country: e && e.target && e.target.value,
                  })
                }
                fluid
                placeholder="Country"
              />
            </Form.Field>
          </Form.Group>
          <Form>
            <Form.Checkbox
              inline
              onChange={() => setChecked(!checked)}
              label="I agree to the terms and conditions"
              checked={checked}
            />
          </Form>
          <Divider />
          <Form.Button
            color="green"
            floated="right"
            disabled={!checked}
            onClick={handleSubmit}
          >
            Update
          </Form.Button>
        </Form>
      </Segment>
    </Container>
  );
}

export default Profile;
